import styled from 'styled-components';

import { media } from '@bitcoin-portal/verse-web-components/dist/themes/breakpoints';

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  text-align: center;

  margin: -150px auto 0;
  max-width: 740px;
  width: 100%;
  z-index: 1;

  & > h2 {
    font-size: 34px;
    font-weight: 700;
    text-transform: uppercase;
  }

  & > p {
    padding: 0 60px;
  }

  & > :last-child {
    margin-top: 16px;
  }

  ${media.sm`
    margin: -300px auto 0;

    & > h2 {
      font-size: 50px;
    }    
  `}
`;
